// Typelizer digest d34e749f4e71f38f267b04ce0f132398
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /c/:company_id/products */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/products', {}, options),
    method: 'get',
  }),

  /** POST /c/:company_id/products */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/products', {}, options),
    method: 'post',
  }),

  /** PATCH /c/:company_id/products/:id */
  update: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/products/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /c/:company_id/products/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/products/:id', params, options),
    method: 'delete',
  }),
}
